import { useEffect } from 'react';

/**
 * Component that redirects to an external URL
 */
const RedirectExternal = (props: { to: string | undefined }) => {
  const { to } = props;
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof to !== 'undefined') {
      window.location.replace(to);
    }
  }, [to]);

  return null;
};

export default RedirectExternal;
